import styled from 'styled-components';

export const Content = styled.div`
  text-align: center;

  p.description {
    color: var(--color-text);
    margin: 30px 0;
  }

  .checkbox-wrapper {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 11px;
    line-height: 100%;
    color: var(--color-text-muted);
    margin-bottom: 20px;
    a {
      text-decoration: underline;
      :hover {
        text-decoration: none;
      }
    }
  }

  .mutedLabel {
    color: var(--color-text-muted);
  }

  .buttonContainer {
    width: 300px;
    max-width: 100%;
    display: flex;
    justify-content: center;
    grid-gap: 10px;
    margin: 0 auto;
  }
`;
